// MULTI-SPACE-ACCESS (founder request 2026-10-30): a channel or a page keeps one home space and may
// be shared into more spaces, each with a level its members get (the space roles of 05 `space`:
// `owner` full, `editor` edit, `viewer` read). The routes live with their item (`channels.shares.*`
// in chat.ts, `pages.shares.*` in pages.ts); these are the shapes both use.
import { z } from "zod";
import { SpaceShareLevel, SpaceShareObjectType } from "../enums";
import { Timestamp, Uuid } from "../primitives";

/** At most this many extra spaces per item. */
export const SPACE_SHARE_MAX = 20;

/** One more space an item is shared into, with the level its members get. */
export const SpaceShareInput = z
  .strictObject({ space_id: Uuid, level: SpaceShareLevel })
  .meta({ id: "SpaceShareInput" });

/** A share as read back: the item, the space it is shared into, the level. */
export const SpaceShare = z
  .object({
    object_type: SpaceShareObjectType,
    object_id: Uuid,
    space_id: Uuid,
    level: SpaceShareLevel,
    created_at: Timestamp,
  })
  .meta({ id: "SpaceShare" });
export type SpaceShare = z.infer<typeof SpaceShare>;

/**
 * `PUT …/shares`: the item's shares into the spaces the caller may add to. A share into a space
 * the caller cannot edit is kept as it is (it is someone else's to change).
 */
export const SpaceShareSet = z
  .strictObject({ shares: z.array(SpaceShareInput).max(SPACE_SHARE_MAX) })
  .meta({ id: "SpaceShareSet" });

/** The shares the caller can see: on items it can view, into spaces it can view. */
export const SpaceShareList = z
  .object({ data: z.array(SpaceShare) })
  .meta({ id: "SpaceShareList" });

export const SpaceShareListQuery = z.object({ object_id: Uuid.optional() });
